import Alert from '@anm/components/notification/Alert';
import { getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { FC } from 'react';

import { UserLimitsProps } from '../types';

import { ChargePrices, UpgradeBlock, Wrapper } from './Wrapper';

const LimitsFooter: FC<Pick<UserLimitsProps, 'perMonthCharge' | 'thisMonthCharge'>> = ({
  perMonthCharge,
  thisMonthCharge
}) => (
  <Wrapper>
    {perMonthCharge || thisMonthCharge ? (
      <Alert variant="info" position="center">
        <span>Total extra charges:</span>
        <ChargePrices>
          <b>{`$${perMonthCharge}/month`}</b>
          <br />
          <b>{`$${thisMonthCharge} this month`}</b>
        </ChargePrices>
      </Alert>
    ) : (
      <UpgradeBlock>
        <p>
          Need more?&nbsp;
          <a {...getUpgradeLinkProps()}>Upgrade to increase your limits</a>
        </p>
      </UpgradeBlock>
    )}
  </Wrapper>
);

export default LimitsFooter;
